import axios from '@axios'

export const state = {
  terminals: [],
  currentPage: 1,
  perPage: 15,
  totalPage: 1,
  totalRecord: 0,
}

export const getters = {
  allTerminals: (state) => state.terminals,
  currentPage: (state) => state.currentPage,
  perPage: (state) => state.perPage,
  totalPages: (state) => state.totalPages,
  totalRecords: (state) => state.totalRecords,
}

export const mutations = {
  GET_TERMINAL: (state, resp) => {
    if (!resp) return null
    state.terminals = resp.terminals
    state.currentPage = resp.page
    state.perPage = resp.perPage
    state.totalPages = resp.totalPages
    state.totalRecords = resp.totalRecords
  },
  DELETE_TERMINAL: (state, terminal) => {
    state.terminals = state.terminals.filter((w) => w.id !== terminal.id)
  },
}

export const actions = {
  async getTerminals({ commit }, params = {}) {
    await axios
      .get('/api/terminals', { params: params })
      .then((resp) => {
        if (resp.status === 200) {
          commit('GET_TERMINAL', resp.data)
        }
      })
      .catch((err) => {
        commit(
          'GET_TERMINAL',
          err.response.status === 404 ? { terminals: [] } : null
        )
      })
  },
  async createTerminal({ commit }, terminal) {
    return axios.post(`/api/terminals`, terminal)
  },
  async editTerminal({ commit }, terminal) {
    return axios.put(`/api/terminals`, terminal)
  },
  async deleteTerminal({ commit }, terminal) {
    await axios.delete(`/api/terminals/${terminal.id}`).then((resp) => {
      if (resp.status === 204) {
        commit('DELETE_TERMINAL', terminal)
      }
    })
  },
}
